import { GetTransportOrderExportQueryParams } from '../../transportOrderApi';
import { ApiTransportOrderExportQueryParams } from '../../types/transportAssignment/queryParameterApi.types';
import { mapFilterableStatusesToApiStatuses } from './outgoingRequestMappers';

export const mapToApiTransportOrderExportQueryParameters = (
    queryParameters: GetTransportOrderExportQueryParams,
): ApiTransportOrderExportQueryParams => ({
    loading_location: queryParameters.loadingLocation,
    unloading_location: queryParameters.unloadingLocation,
    statuses: queryParameters.statuses && mapFilterableStatusesToApiStatuses(queryParameters.statuses),
    archived: queryParameters.archived,
    order_issued_at_start: queryParameters.orderIssuedAtStart?.toISOString(),
    order_issued_at_end: queryParameters.orderIssuedAtEnd?.toISOString(),
});
